import { http } from "../client";
export var playNextTrack = function (id) {
    return http.api.post("devices/" + id + "/next");
};
